import util from '@bmp-vue/core/api/util'

const controller = 'Agencias'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']))
